export default function WhyUsSection() {
  const features = [
    {
      icon: 'ri-shield-check-line',
      title: '品质保障',
      desc: '每份资源均经过人工审核筛选，确保内容质量上乘、实用可靠，拒绝低质滥竽充数。',
    },
    {
      icon: 'ri-download-cloud-2-line',
      title: '高速下载',
      desc: '多线路CDN加速，热门资源提供网盘分流，确保您能快速稳定地获取所需资源。',
    },
    {
      icon: 'ri-refresh-line',
      title: '每日更新',
      desc: '专业团队持续更新，每周新增200+份资源，紧跟热点趋势，资源库始终保持新鲜。',
    },
    {
      icon: 'ri-price-tag-3-line',
      title: '完全免费',
      desc: '坚持免费分享理念，所有资源均可免费下载使用，让优质资源惠及每一位用户。',
    },
    {
      icon: 'ri-group-line',
      title: '社区共建',
      desc: '开放用户投稿渠道，优质资源由社区共同贡献，人人都是资源库的建设者和受益者。',
    },
    {
      icon: 'ri-customer-service-2-line',
      title: '贴心服务',
      desc: '提供详细的资源使用教程和说明文档，遇到问题有专人解答，使用无忧。',
    },
  ];

  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            为什么选择给力资源库
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            六大核心优势，为您打造最佳资源获取体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {features.map((item, idx) => (
            <div
              key={idx}
              className="flex gap-4 p-5 md:p-6 rounded-xl bg-background-50 border border-background-200/70 hover:border-accent-200 transition-all duration-300 group"
            >
              <div className="w-12 h-12 flex-shrink-0 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 group-hover:bg-accent-200 group-hover:text-accent-700 transition-all duration-300">
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <div>
                <h3 className="font-heading text-base font-bold text-foreground-900 mb-1.5">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}